import { useActions } from "./useActions"
import { useLoadMore as useBaseLoadMore, useNostoAppState } from "@nosto/search-js/preact/hooks"
import { getNextPageQuery } from "@nosto/search-js/preact/legacy"

/**
 * Hook for loading more results by specified pageSize value
 * @example
 * ```jsx
 *  function LoadMoreButton({ pageSize }) {
 *     const { loadMore, href } = useLoadMore(pageSize)
 *
 *     return (
 *         <a
 *              class="ns-load-more-button ns-act-btn ns-act-btn-light"
 *              onClick={loadMore}
 *              href={href}
 *          >
 *              More results
 *         </a>
 *    )
 * }
 * ```
 * @param pageSize - number of additional products to load (default=24)
 * @group Hooks
 */
export function useLoadMore(pageSize = 24) {
    const { from, size } = useNostoAppState(state => ({
        from: state.query.products?.from ?? 0,
        size: state.query.products?.size ?? 0
    }))
    const { simulateUpdateSearch } = useActions()

    const { loadMore: loadMoreBase } = useBaseLoadMore(pageSize)
    const href = simulateUpdateSearch(getNextPageQuery({ from, size, pageSize })).url.toString()

    // Backward compatibility with prevent default, since search-js does not have that
    function loadMore(event?: MouseEvent) {
        event?.preventDefault()
        loadMoreBase()
    }

    return {
        loadMore,
        href
    }
}
